import React from "react";
import { StepItem } from "../Shared";

export default ({ message }) => {
  return <StepItem>{message}</StepItem>;
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/WelcomeMessage.js